"use client"

import { Fence } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FenceIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FenceIcon = component(Icon)({ as: Fence })
